import store from '../vuex/store';
import router from "../router";

function validarSePossuiPapelParaVerPedido(usuarioLogado) {
    const papeisQuePodemVer = ["APROVADOR_FINANCEIRO", "APROVADOR_CONTABILIDADE", "ADMIN", "PROCURADOR", "APROVADOR_FINANCEIRO_EXCECAO"];
    var possuiPapelParaVisualização = false;
    for (var i = 0; i < usuarioLogado.papeis.length; i++) {
        possuiPapelParaVisualização = papeisQuePodemVer.indexOf(usuarioLogado.papeis[i].nome) != -1
        if (possuiPapelParaVisualização) break
    }
    return possuiPapelParaVisualização;
}
function validarSeEhUsuarioAprovadorOuRegistrador(usuariosDoPedido, usuarioLogado) {
    const ehAprovadorOuRegistrador = usuarioLogado.id == usuariosDoPedido.idAprovador || usuarioLogado.id == usuariosDoPedido.idRegistrador;
    return ehAprovadorOuRegistrador;
}
export function validarSeUsuarioLogadoPodeVerPedido(usuariosDoPedido) {
    const usuarioLogado = JSON.parse(localStorage.getItem("usuarioLogado"));
    const ehAprovadorOuRegistrador = validarSeEhUsuarioAprovadorOuRegistrador(usuariosDoPedido, usuarioLogado);
    const possuiPapelParaVisualização = validarSePossuiPapelParaVerPedido(usuarioLogado);
    const usuarioPossuiPermissao = ehAprovadorOuRegistrador || possuiPapelParaVisualização;
    if (!usuarioPossuiPermissao) {
        store.commit('snackErro', `Você não possui permissão para acessar este pedido!`);
        setTimeout(() => {
            router.go(-1)
        }, 2000)
    }
    return usuarioPossuiPermissao;
}
